import React from "react";
import { MainButton } from "../Buttons/MainButton/MainButton";
import dataPrivacyIcon from "../../images/dataPrivacyIcon.svg";
import affordableIcon from "../../images/affordableIcon.svg";
import computableIcon from "../../images/computableIcon.svg";
import { colors } from "../../constants/colors";
const Feature = ({ imgSrc, imgAlt, title, details, aosTime }) => {
  return (
    <div
      id="about"
      className="feature-box"
      data-aos="fade-left"
      data-aos-delay={aosTime}
      // data-ix="up-icon-on-hover"
      style={{
        padding: "2vw",
        opacity: 1,
        transform: "translateX(0px) translateY(0px) translateZ(0px)",
        transition: "opacity 500ms ease 0s, transform 500ms ease 0s",
      }}
    >
      <div>
        <img
          className="features-icon"
          width={100}
          src={imgSrc}
          alt={imgAlt}
          // alt="Blue email icon"
          style={{
            paddingTop: "10px",
            transformStyle: "preserve-3d",
            transition: "transform 750ms ease 0s, opacity 750ms ease 0s",
            opacity: 1,
            transform: "translateX(0px) translateY(0px) translateZ(0px)",
          }}
        />
      </div>
      <h4 style={{ color: colors.gencRed }}>{title}</h4>
      <p style={{ color: colors.gencBlack }}>{details}</p>
    </div>
  );
};
export const About = ({ handleShowHideModalRequest }) => {
  const features = [
    {
      title: "Secure & Private",
      details:
        "Built with Hybrid-blockchain Technology and strictly adhere to Zero-knowledge Server Protocols means your health data are impossible to access by anyone else but you and your apps.",
      imgSrc: dataPrivacyIcon,
      imgAlt: "Privacy Icon",
    },
    {
      title: "Affordable",
      details:
        "Storing files on the Blockchain is secure but expensive. GenC helps bringing the cost down so that you and Generation C users can afford to store heavy files such as X-rays or even videos",
      imgSrc: affordableIcon,
      imgAlt: "Affordable Icon",
    },
    {
      title: "Computable",
      details:
        "Your health database grows as you age. Computability means your data can be connected to your selected apps and train your AI agents to assist you mininizing the ill-effects of aging.",
      imgSrc: computableIcon,
      imgAlt: "Privacy Icon",
    },
  ];
  let aosTime = 500;
  return (
    <section style={{ backgroundColor: colors.gencWhite }}>
      <div
        className="content-wrapper"
        style={{
          marginBottom: 0,
          padding: "3vw",
        }}
      >
        <div className="header-text">
          <h1 style={{ color: colors.gencBlue, marginBottom: 0 }}>
            Your Family's Online Health-Box
          </h1>
          <hr
            style={{
              width: "25%",
              height: "3px",
              textAlign: "center",
              backgroundColor: colors.gencBlue,
              marginTop: 2,
            }}
          />
          <p style={{ color: colors.gencBlack }}>
            <b>Decentralized and private data containers</b> <br></br>for you
            and your loved ones to secure, connect, and model health data
          </p>
          {/* <h2 className="heading-2">
          Decentralized and private data containers&nbsp;
          <span className="thin">
            for you and your loved ones to secure, connect, and model health
            data
          </span>
        </h2> */}
        </div>
        <div className="flex-wrapper space-between">
          {features.map((props, index) => {
            aosTime += 250;
            return (
              <Feature key={`feature-${index}`} {...props} aosTime={aosTime} />
            );
          })}
        </div>
        <div style={{ justifyContent: "center", display: "flex" }}>
          <MainButton
            text={"Request a FREE GenC Health Sandbox"}
            onClick={handleShowHideModalRequest}
            style={{ padding: "20px" }}
          />
        </div>
      </div>
    </section>
  );
};
